<template>
  <div id="reserves">
    <v-card class="mb-3">
      <v-card-title>
        Бронирование
      </v-card-title>
    </v-card>
    <v-card>
      <workout-table
        :fetch-items="fetchWorkouts"
        :fetch-summary-items="fetchSummaryWorkouts"
        :show-summary="true"
        :show-gym-filter="true"
        :show-manual-finish="true"
      />
    </v-card>
  </div>
</template>

<script>
import WorkoutTable from "@/components/workout/table/index.vue";
import workoutData from "@/mixins/WorkoutData";

export default {
  mixins: [workoutData],
  components: {
    WorkoutTable,
  },
  data() {
    return {
      items: [],
      total: 0,
      loading: false,
    };
  },
  methods: {
    async getPreparedWorkouts(page, itemsPerPage, input) {
      const result = await this.$api.workout.workouts(page, itemsPerPage, input);
      const workouts = result.data?.data?.workouts ?? {};
      let products = {};

      try {
        products = await this.$api.workout.workoutsProducts(
          (workouts.data ?? []).map((item) => item.id)
        );
      } catch (e) {
        // Не удалось получить продукты
      }

      return {
        data: this.prepareResponseWorkouts(
          workouts.data ?? [],
          products.data?.data?.getWorkoutsProducts ?? []
        ),
        paginatorInfo: workouts.paginatorInfo,
      };
    },
    async fetchWorkouts(payload) {
      return this.getPreparedWorkouts(
        payload.page,
        payload.itemsPerPage,
        payload.input
      );
    },
    async fetchSummaryWorkouts(payload) {
      const total = payload.total ?? 0;

      if (total === 0) {
        return [];
      }

      if (total === 1) {
        const singleItemData = await this.getPreparedWorkouts(1, 1, payload.input);
        return singleItemData.data;
      }

      const fullData = await this.getPreparedWorkouts(1, total, payload.input);
      return fullData.data;
    },
  },
};
</script>
